export default __webpack_public_path__ + "static/media/message.bf24c5b6.svg";